import { useLocale } from '@solinkcorp/locale';
import { Card, CardContent } from '@solinkcorp/solink-ui/components/Card';
import { cn } from '@solinkcorp/solink-ui/lib/utils';
import { Plus } from 'lucide-react';

interface EmptyLayoutProps {
  addAction: (() => void) | undefined;
}

export default function EmptyLayout({ addAction }: EmptyLayoutProps) {
  const locale = useLocale();
  return (
    <div className="flex h-full items-center justify-center p-3">
      <Card className="h-full w-full">
        <CardContent className="flex h-full items-center justify-center p-8">
          <div className="flex flex-col items-center justify-center gap-8 text-center">
            {addAction && (
              <button
                onClick={addAction}
                className={cn(
                  'group flex h-[120px] w-[120px] items-center justify-center',
                  'rounded-lg border-2 border-dashed border-muted-foreground/50',
                  'bg-transparent transition-colors',
                  'hover:border-primary hover:bg-primary/10',
                )}
              >
                <Plus className="h-12 w-12 transition-colors text-muted-foreground/80 group-hover:text-primary" />
              </button>
            )}
            <div className="flex flex-col gap-6">
              <h2 className="text-[1.75rem] font-medium">
                {locale.serviceDisplayMonitor.emptyLayoutWelcome}
              </h2>
              <p className="text-muted-foreground">
                {addAction
                  ? locale.serviceDisplayMonitor.emptyLayoutDescription
                  : locale.serviceDisplayMonitor.emptyLayoutDescriptionReadOnly}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
